import React from 'react'
import { Grid } from '@mui/material'
import { useTranslate } from 'react-admin'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'

export const BaggageTab = ({ product, loading }) => {
  const translate = useTranslate()
  
  const amount = typeof product === 'object' ? product.amount : product
  const currency = typeof product === 'object' ? product.currency || 'ARS' : 'ARS'
  const formattedAmount = numberFormatterWithDecimalAndThousand(amount)

  return (
    <Grid container spacing={2}>
      <ShowListElement
        sm={2}
        label="Monto"
        value={loading ? translate('ra.action.loading') : `${currency} ${formattedAmount}`}
      />
    </Grid>
  )
}